import { LIST_REVIEW, LIST_REVIEW_FAIL, GET_REVIEW, DELETE_REVIEW } from '../actions/types'

const initialState = {
  list: null,
  details: null,
  delete: null,
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case LIST_REVIEW:
      return {
        ...state,
        list: payload,
      }
    case LIST_REVIEW_FAIL:
      return {
        ...state,
        list: null,
      }
    case GET_REVIEW:
      return {
        ...state,
        details: payload,
      }
    case DELETE_REVIEW:
      return {
        ...state,
        delete: payload,
      }
    default:
      return state
  }
}
